import axios from "axios";

import globals from "../../globlas";
import { _sendWithAxios } from "../api";

// Funções para Participantes
export const listarParticipantes = async (filtro = "", isAdmin = "", status = "", page = 1, pageSize = 10, perfil = "") => {
  let url = `${globals.REACT_APP_URL_BASE_API}Usuario/listagem/${page}/${pageSize}`;
  
  const params = [];
  if (filtro) params.push(`filter=${encodeURIComponent(filtro)}`);
  if (isAdmin !== "") params.push(`isAdmin=${isAdmin}`);
  if (status) params.push(`status=${encodeURIComponent(status)}`);
  if (perfil) params.push(`perfil=${encodeURIComponent(perfil)}`);
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  return await _sendWithAxios(url, "GET");
};

export const buscarParticipantePorId = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}participantes/${id}`,
    "GET"
  );
};

export const cadastrarParticipante = async (data) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}participantes/cadastrar`,
    "POST",
    data
  );
};

export const alterarParticipante = async (id, data) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}participantes/alterar?id=${id}`,
    "PUT",
    data
  );
};

// Funções para Administradores
export const listarAdministradores = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}administradores/listagem`,
    "GET"
  );
};

export const buscarAdministradorPorId = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}administradores/${id}`,
    "GET"
  );
};

export const cadastrarAdministrador = async (data) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}administradores/cadastrar`,
    "POST",
    data
  );
};

export const alterarAdministrador = async (data) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIBASE_LOGIN}administradores`,
    "PUT",
    data
  );
};

// Função para extrair relatório de usuários
export const extrairRelatorioUsuarios = async () => {
  return await axios.get(
    `${globals.REACT_APP_URL_BASE_API}Usuario/relatorio-usuarios`,
    {
      responseType: "blob",
    }
  );
}; 
